import { useCallback, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

const DETOUR_ROOTS = ['/help', '/my-account']

// Pages opened from the top bar that offer a "Back" button instead of the
// profile switcher.
export function isDetourPath(pathname: string) {
  return DETOUR_ROOTS.some(
    (root) => pathname === root || pathname.startsWith(`${root}/`)
  )
}

// Remembers the last page outside the detour pages, so "Back" can return
// there instead of to the default dashboard.
export function useReturnPath(): () => string | null {
  const { pathname, search, hash } = useLocation()
  const lastPath = useRef<string | null>(null)

  useEffect(() => {
    if (!isDetourPath(pathname)) {
      lastPath.current = `${pathname}${search}${hash}`
    }
  }, [pathname, search, hash])

  return useCallback(() => lastPath.current, [])
}
